import type { FaireProductEntity } from "../../entity_types/product";

export const p_php6rwgsa6: FaireProductEntity = {
  token: "p_php6rwgsa6",
  type: "product",
  name: "Wedding Vows Book: A Set of Two Keepsake Books for Weddings",
  brandToken: "b_x27fkb4h4a",
  brandName: "Paige Tate & Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/27232b1b2cd3757fbdae65e722138e9cd48891c3260c12aaef1f2b79ea475e56.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e8ab9903735eb842e2c3c36d1be98479194371d93821d3c353b8bea1fbe43d41.jpeg",
    "https://cdn.faire.com/fastly/4d6771a81a6887a863c8654e07c6ba31eac8753d03485a577b0e8cc5077cdac2.jpeg",
    "https://cdn.faire.com/fastly/d87d38e97a22191054597eb85445d2da6d41f6648abd35805ead0df89c6d9e9f.jpeg",
    "https://cdn.faire.com/fastly/2460c1a993372b778dc8c2133b4106d54cb62554d0425bfa1246ff929ef47645.jpeg",
    "https://cdn.faire.com/fastly/b7074e9b3eafcb966bc38b7c6fc4783d144f48eba0efbc0770d379c82a5acbc5.jpeg",
    "https://cdn.faire.com/fastly/27e0121a7fadf4d5e9cbc40357d2e711bb1b715d19d4b485fa68c0a3a13702a3.jpeg",
  ],
  priceDollars: 27.35,
  description:
    "Capture and celebrate the words you share on your wedding day with this beautiful set of heirloom-quality wedding vows journals! From bestselling author Korie Herold, these beautifully-designed vow books features foil accents and hand-drawn illustrations to give them an elegant look and feel at the altar. Pair them with the Korie Herold collection's Wedding Guest Book and her memory book for couples As We Grow.\n\n• Set of two vow books with linen covers and gold foil\n• Archival, acid-free pages to preserve vows for generations\n• Lay-flat binding for easy reading and recitation at the altar\n• Complements the Korie Herold collection: As We Grow and Wedding Guest Book\n\nCategories: wedding, couples memory book, books, couples gifts, journals, bride, wedding gifts, vows book, wedding vows, promise vows, vow booklets, couples journal, Faire Market 2026",
  tags: [],
  msrpDollars: 54.72,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:48.160Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
